module.exports = __webpack_public_path__ + "image-7616ea72759c.png";